import { defaultMemoize } from 'reselect';
import formatAttendeeName from '../../../utils/formatAttendeeName.js';

export const ROOMMATE_DISPLAY_FIELDS = {
  COMPANY: 'company',
  TITLE: 'title',
  STATE: 'stateCode',
  COUNTRY: 'countryCode',
  REGISTRATION_TYPE: 'registrationType'
};

/**
 * Get sorted groups of roommates. Grouped by starting character of name, all alphabetically sorted.
 * @param  {} availableRoommates
 * @param cultureCode used for alphabetical sorting of roommates by name
 */
export const getSortedGroups = defaultMemoize((availableRoommates, cultureCode = 'en') => {
  const groupedByFirstChar = availableRoommates.reduce((accumulator, current) => {
    const id = current.name.charAt(0).toUpperCase();
    const group = accumulator[id];
    if (group) {
      group.push(current);
    } else {
      accumulator[id] = [current]; // eslint-disable-line no-param-reassign
    }
    return accumulator;
  }, {});
  return Object.keys(groupedByFirstChar)
    .map((key) => ({
      groupName: key,
      roommates: groupedByFirstChar[key]
        .sort((one, two) => one.name.localeCompare(two.name, cultureCode, { ignorePunctuation: true }))
    }))
    .sort((one, two) => one.groupName.localeCompare(two.groupName, cultureCode, { ignorePunctuation: true }));
});

/**
 * roommate search logic
 * @param roommates
 * @param keyword
 * @returns {*|Array}
 */
export function filterRoommates(roommates, keyword) {
  return roommates.filter(r => {
    const fullName = r.name || formatAttendeeName({ firstName: r.firstName, lastName: r.lastName });
    return fullName.toLowerCase().includes(keyword.toLowerCase()) ||
      (r.companyName && r.companyName.toLowerCase().includes(keyword.toLowerCase()));
  }) || [];
}

/**
 * returns the sub fields to be displayed in roommate list below each invitee name
 * based on site editor display settings and validity of field value
 * @param  {} item
 * @param  Array roommateDisplayFields=[]
 */
export function getFieldsToDisplay(item, roommateDisplayFields = []) {
  let fieldsToDisplay = [];
  if (roommateDisplayFields.includes(ROOMMATE_DISPLAY_FIELDS.COMPANY) && item.companyName) {
    fieldsToDisplay.push(item.companyName);
  }
  if (roommateDisplayFields.includes(ROOMMATE_DISPLAY_FIELDS.TITLE) && item.title) {
    fieldsToDisplay.push(item.title);
  }
  if (roommateDisplayFields.includes(ROOMMATE_DISPLAY_FIELDS.STATE) && item.stateCode) {
    fieldsToDisplay.push(item.stateCode);
  }
  if (roommateDisplayFields.includes(ROOMMATE_DISPLAY_FIELDS.COUNTRY) && item.countryCode) {
    fieldsToDisplay.push(item.countryCode);
  }
  if (roommateDisplayFields.includes(ROOMMATE_DISPLAY_FIELDS.REGISTRATION_TYPE) && item.registrationTypeName) {
    fieldsToDisplay.push(item.registrationTypeName);
  }
  return fieldsToDisplay;
}
